<!--
  - Copyright (c) 2023. Haodong JU
  -->

<template>
  <div>
    <v-container>
      <ik-data-table
        ref="table"
        :model="model"
        entity-name="RechargeType"
        icon="mdi-cash-usd"
      />
    </v-container>
  </div>
</template>

<script>

import IkDataTable from '@/plugins/EntityFrameWork/IkDataTable.vue'
import VipPay from '@/model/dataLayer/api/Vip/VipPay'

export default {
  components: {
    IkDataTable
  },
  data: function () {
    return ({
      model: VipPay
    })
  }
}
</script>
